var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useId, useState } from "react";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getLanguageFromStorage } from "syf-js-utilities";
import Collapse from "syf-component-library/ui/atoms/Collapse";
import useWindowSize from "syf-component-library/ui/customHooks/useWindowWidth";
import { DesktopCardContainer } from "../../ui/layouts/DesktopCard/DesktopCard.styles";
import { CollapseButton, CollapseCardContainer, CollapseHeader, MobileCardContainer, } from "../../ui/layouts/MobileCard/MobileCard.styles";
import ErrorComponent from "./ErrorComponent";
import { ErrorContainer, ErrorMobileWrapper } from "./ErrorWrapper.styles";
import { useConfig } from "../../hooks/useConfig";
import { CardHeader } from "../../ui/molecules/CardHeader";
import i18n from "../../strings/i18n";
import { IMAGE_ACCOUNT_CARD_LOGO } from "../../const/assets";
var ErrorWrapper = function (_a) {
    var isError = _a.isError, children = _a.children, isExpandedByDefault = _a.isExpandedByDefault;
    var windowWidth = useWindowSize();
    var hosts = useConfig().hosts;
    var lang = getLanguageFromStorage();
    var syfLogoSource = "".concat(hosts === null || hosts === void 0 ? void 0 : hosts.assets).concat(IMAGE_ACCOUNT_CARD_LOGO);
    var _b = useState(isExpandedByDefault || false), isExpanded = _b[0], setIsExpanded = _b[1];
    var collapseIcon = isExpanded ? faChevronUp : faChevronDown;
    var handleHeaderOnClick = function () {
        setIsExpanded(isExpandedByDefault || !isExpanded);
    };
    var headerData = {
        displayName: i18n({ error: "error" }),
        accountLast4: "",
        portfolioLogo: syfLogoSource,
        isExpandedByDefault: isExpandedByDefault || false,
        isLoan: false,
        isLinkEnabled: false,
        isNickNameButton: false,
        accountId: "",
        isSecuredInstallment: false,
        isError: true,
    };
    var cardHeaderId = useId();
    if (isError) {
        return !windowWidth.isLessThanMobile ? (_jsx(DesktopCardContainer, __assign({ "data-testid": "error-card-container" }, { children: _jsxs(ErrorContainer, { children: [_jsx(CardHeader, __assign({}, headerData, { notificationList: [] })), _jsx(ErrorComponent, {})] }) }))) : (_jsx(ErrorMobileWrapper, __assign({ "data-testid": "error-card-container" }, { children: _jsxs(MobileCardContainer, { children: [_jsxs(CollapseHeader, { children: [_jsx(CardHeader, __assign({}, headerData, { cardHeaderId: cardHeaderId, notificationList: [] })), !headerData.isExpandedByDefault && (_jsx(CollapseButton, __assign({ onClick: handleHeaderOnClick, "aria-expanded": isExpanded, "aria-labelledby": cardHeaderId }, { children: _jsx(FontAwesomeIcon, { icon: collapseIcon }) })))] }), _jsx(Collapse, __assign({ expand: isExpanded, id: "Error-collased-header" }, { children: _jsx(CollapseCardContainer, __assign({ lang: lang }, { children: _jsx(ErrorComponent, {}) })) }))] }) })));
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return _jsx(_Fragment, { children: children });
};
export default ErrorWrapper;
//# sourceMappingURL=ErrorWrapper.js.map